import React from 'react';

/** Avatar from numeric user id (admin community mock / API). */
export default function CommunityAvatar({ userId, size = 40, className = '' }) {
  const id = userId != null ? String(userId) : '?';
  const initial = id.length >= 2 ? id.slice(-2) : id;
  const hue = (Number(userId) || 0) % 360;

  return (
    <div
      className={`rounded-full flex items-center justify-center font-semibold shrink-0 border border-dark-border text-dark-text ${className}`}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.32)),
        background: `hsl(${hue} 35% 22%)`,
      }}
      aria-hidden
    >
      {initial}
    </div>
  );
}
